/*
 * Third-party consent orchestrator (loaded as the "ads" webpack entry, injected
 * into the SSR shell for non-premium users). It reads the consent decision made
 * via our own banner and loads only the scripts the user allowed:
 *   - analytics granted → Google Tag Manager + Cloudflare (loadAnalytics)
 *   - ads granted       → Freestar / pub.network (loadAds)
 * Nothing loads until the user decides, and it re-applies whenever the decision
 * changes (the banner dispatches a window event that reaches this bundle too).
 */

import {
  adsEnabled,
  type ConsentState,
  getConsent,
  loadAnalytics,
  onConsentChange,
} from "@typeblind/thirdparties";
import { loadAds } from "./scripts.ts";
import { showAdBlockerStatus } from "./status.ts";

main();

function main(): void {
  apply(getConsent());
  onConsentChange((state) => {
    apply(state);
  });
}

function apply(consent: ConsentState | null): void {
  if (consent == null) {
    // No decision yet — load nothing (opt-in). The banner is shown by the app.
    return;
  }

  if (consent.analytics) {
    loadAnalytics();
  }

  // `adsEnabled` is checked before the consent flag, not after: a visitor may
  // carry a stored decision that granted ads from before advertising was turned
  // off. Calling `loadAds` then would report failure and put up the ad-blocker
  // nudge, blaming the visitor for a site setting.
  if (adsEnabled && consent.ads) {
    loadAds()
      .then((loaded) => {
        // `loaded` is false when an ad-blocker prevented the script — show the
        // "please disable your ad-blocker or go premium" nudge in that case.
        showAdBlockerStatus(loaded);
      })
      .catch((err) => {
        console.error(err);
      });
  } else {
    // Ads declined or switched off — hide the placeholders entirely (no nudge).
    showAdBlockerStatus(true);
  }
}
